import script from "./VueDragResize.vue?vue&type=script&setup=true&lang=js"
export * from "./VueDragResize.vue?vue&type=script&setup=true&lang=js"

import "./VueDragResize.vue?vue&type=style&index=0&id=5141e90f&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5141e90f"]])

export default __exports__